// React
import { useEffect, useState } from "react"

// Types
import type { SuccessFetch } from "types"
import type { DataType } from "../../types"

// Utils
import { useApi } from "utils"

// Types
interface FetchType {
	coa_code: string
	coa_name: string
	coa_id: number
	header_level: number
}

export function useCoaList(): {
	data: DataType[]
	isLoading: boolean
} {
	// Hooks
	const api = useApi()
	const [data, setData] = useState<DataType[]>([])
	const [isLoading, setLoading] = useState(true)

	useEffect(() => {
		api.get(
			"/coa/"
		).then((res: SuccessFetch<{ payload: FetchType[] }>) => {
			setData(res.data.payload.filter(item => {
				return item.header_level < 3
			}).map(item => ({
				coa_code: item.coa_code,
				coa_name: item.coa_name,
				label: `${item.coa_code} ${item.coa_name}`,
				value: item.coa_id.toString()
			})))
		}).catch(() => {
			setData([])
		}).finally(() => {
			setLoading(false)
		})

		return () => {
			setData([])
			setLoading(false)
		}

		// eslint-disable-next-line
	}, [])

    return { data, isLoading }
}